import { SCHEDULE_CONFIG as C } from './scheduleConfig';
import { calcAge } from './dateUtils';

/**
 * Данные пациента для строки расписания: возраст, дата рождения, последняя анкета.
 * cache (Map) живёт на один проход отрисовки, чтобы не дёргать API дважды за одного пациента.
 */
export function getPatientCard(customerId, cache = new Map()) {
    if (cache.has(customerId)) return cache.get(customerId);

    const patient = global.api.searchPatient(customerId);
    const birth = new Date(patient.ClientDateBirth);
    const list = global.api.profileList(customerId);
    const last = list && list.length ? list[0] : null;

    const card = {
        age: calcAge(birth),
        birthText: birth.toLocaleDateString(C.LOCALE),
        lastAnketa: last && {
            id: last.id,
            dateTime: new Date(last.date).toLocaleDateString(C.LOCALE, { timeZone: 'Asia/Almaty', hour: '2-digit', minute: '2-digit' }),
            dateShort: new Date(last.date).toLocaleDateString(C.LOCALE, { timeZone: 'Asia/Almaty' }),
        },
    };
    cache.set(customerId, card);
    return card;
}

export function buildAnketaButton(a) {
    if (!a) return '';
    return `<button class="btn btn-seeForm" type="button" data-controller="database" data-action="click->database#goToDoc" data-database-id-param="${a.id}" data-database-date-param="${a.dateTime}">от ${a.dateShort}</button>`;
}
